export class ProcessName{
    public static readonly OTP:string = "OTP_Standart";
    public static readonly Registration:string = "Registration";
    public static readonly UpdatePhone:string = "UpdatePhone";
    public static readonly LoginPassword:string = "LoginPassword";

    public static getProcessName(processID : string) : string{
        switch(processID)
        {
          case '1':
            return ProcessName.OTP;
          case '2':
            return ProcessName.Registration;
          case '3':
            return ProcessName.UpdatePhone;
          case '6':
            return ProcessName.LoginPassword;
        }
        return "";
      }
}